// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OzgJ","delete":"styles_delete__2AZPP","update":"styles_update__30DJg","add":"styles_add__2lp4-"};